import React, { Component } from 'react'
import { Grid, Col, Row } from 'react-flexbox-grid'
import PaidByOtherTextField from '../../../widgets/SubmitAClaim/PaidByOtherTextField'
import RBSelectField from '../../../controls/RBSelectField'
import RBButton from '../../../controls/RBButton'
import RBDatePicker from '../../../controls/RBDatePicker'
import moment from 'moment'
import { localize } from '../../../util/Localizer'
import TitledLabel from '../../../controls/TitledLabel'
import RBNumericTextBox from '../../../controls/RBNumericTextBox'
import LinearProgress from '@material-ui/core/LinearProgress'
import { formatCurrency } from '../../../util/CurrencyFormatter'
import NgrxUtil from '../../../util/NgrxUtils'

import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { fetchQuantityTypes, fetchProvinces, SearchDIN } from '../../../redux/actions/submitExpenseActions'
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

import {
  createEmptyDrugClaimExpense,
  createEmptyDrugClaimExpenseError,
  validateDinNumberForDrugClaimExpense,
  validateDrugClaimExpense
} from './functions'

class ManageDrugExpense extends Component {
  constructor (props) {
    super(props)

    this.updateValues = this.updateValues.bind(this)
    this.onAddExpense = this.onAddExpense.bind(this)
    this.SearchDrugNumber = this.SearchDrugNumber.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.validate = this.validate.bind(this)
    this.createPostExpenseFromLocalState = this.createPostExpenseFromLocalState.bind(this)

    this.state = {
      claimExpense: createEmptyDrugClaimExpense(),
      claimExpenseError: createEmptyDrugClaimExpenseError(),
      dinState: {
        isValid: false,
        name: '',
        isSearching: false
      }
    }

    this.state = Object.assign(this.state, ManageDrugExpense.loadFromEdit(props, this.state))
  }

  static loadFromEdit (nextProps, state) {
    if (Object.keys(nextProps.claimExpense).length > 0 &&
      JSON.stringify(state.claimExpense) !== JSON.stringify(nextProps.claimExpense)) {
      return {
        claimExpense: ManageDrugExpense.createLocalStateExpenseFromIncomingExpense(nextProps.claimExpense),
        dinState: { isValid: true } // set the dinState to valid since we are editing
      }
    }
    return null
  }

  static createLocalStateExpenseFromIncomingExpense (claimExpense) {
    return {
      serviceDate: claimExpense.ServiceDate,
      dinNum: claimExpense.DrugInfo.DrugIdentificationNumber,
      rxNum: claimExpense.DrugInfo.RxNumber,
      province: { text: claimExpense.DrugInfo.Province, id: claimExpense.DrugInfo.Province },
      supplyDays: claimExpense.DrugInfo.DaysOfSupply,
      quantityType: { text: claimExpense.DrugInfo.DrugQuantityType, id: claimExpense.DrugInfo.DrugQuantityType },
      drugQuantity: claimExpense.DrugInfo.DrugQuantity.toString(),
      drugCost: claimExpense.DrugInfo.DrugCost,
      dispenseFee: claimExpense.DrugInfo.DispenseFee,
      paidAmount: null,
      paidByOtherAmount: claimExpense.COBField ? claimExpense.COBField.COBAmount : 0
    }
  }

  componentDidMount () {
    if (this.props.quantityTypes !== null) {
      this.props.fetchQuantityTypes()
    }
    if (this.props.provinces !== null) {
      this.props.fetchProvinces()
    }
  }

  createPostExpenseFromLocalState () {
    let cob = null
    if (this.state.claimExpense.paidByOtherAmount !== undefined || this.state.claimExpense.paidByOtherAmount !== null) {
      cob = {
        COBAmount: Number(this.state.claimExpense.paidByOtherAmount),
        OriginalTo: 'OC'
      }
    }
    return {
      ClaimLineId: 0,
      ServiceDate: this.state.claimExpense.serviceDate,
      DrugInfo: {
        DaysOfSupply: Number(this.state.claimExpense.supplyDays),
        DispenseFee: Number(this.state.claimExpense.dispenseFee),
        DrugCost: Number(this.state.claimExpense.drugCost),
        DrugIdentificationNumber: this.state.claimExpense.dinNum,
        DrugQuantity: Number(this.state.claimExpense.drugQuantity),
        DrugQuantityType: this.state.claimExpense.quantityType.text,
        RxNumber: this.state.claimExpense.rxNum,
        Province: this.state.claimExpense.province.id
      },
      COBField: cob
    }
  }

  onAddExpense () {
    if (this.validate()) {
      this.props.onAddExpense(this.createPostExpenseFromLocalState())
      this.onCancel()
    }
  }

  onCancel () {
    this.props.onCancel()
  }

  validate (onlyDin = false) {
    const claimExpense = NgrxUtil.deepCopyObject(this.state.claimExpense)
    const claimExpenseError = NgrxUtil.deepCopyObject(this.state.claimExpenseError)

    let isValid = true

    if (this.state.dinState.isValid) {
      isValid = validateDinNumberForDrugClaimExpense(claimExpense, claimExpenseError) && isValid
    } else {
      isValid = false
      claimExpenseError.dinNum = localize('pages.SubmitAClaim.Expenses.Drug.dinError')
    }

    if (!onlyDin) {
      isValid = validateDrugClaimExpense(claimExpense, claimExpenseError, this.props.hasCOB) && isValid
    }

    this.setState({ claimExpenseError })

    return isValid
  }

  onBlur () {
    const claimExpense = { ...this.state.claimExpense }
    if (claimExpense.dinNum.length < 8) {
      this.validate(true)
    }
  }

  updateValues (valueObj) {
    const claimExpense = { ...this.state.claimExpense }

    if (valueObj['serviceDate']) {
      valueObj['serviceDate'] = moment(valueObj['serviceDate']).format('YYYY-MM-DD') // this needs to be in this format for the expenseCard
    }

    if (valueObj['dinNum']) {
      if (valueObj['dinNum'].length === 8) {
        this.SearchDrugNumber(valueObj['dinNum'])
      } else {
        this.setState({ dinState: { isValid: false, name: '' } })
      }
    }

    if (valueObj['province']) {
      valueObj['province'] = {
        text: valueObj['province'],
        id: valueObj['province']
      }
    }

    const updatedClaimExpense = Object.assign(claimExpense, valueObj)

    this.setState({
      claimExpense: updatedClaimExpense,
      claimExpenseError: createEmptyDrugClaimExpenseError()
    })
  }

  quantityTypeChanged = (value) => {
    this.setState({
      claimExpense: { ...this.state.claimExpense, [value.id]: { text: value.text, id: value.value } }
    })
  }

  SearchDrugNumber (dinNum) {
    this.setState({ dinState: { isSearching: true } })
    this.props.SearchDIN(dinNum,
      // handle success
      (result) => {
        this.setState({ dinState: { isValid: true, name: result.name, isSearching: false } })
      },
      // handle the error
      (result) => {
        this.setState({ dinState: { isValid: false, name: '', isSearching: false } })
        this.validate(true)
      })
  }

  renderDrugForm () {
    const { classes = {} } = this.props
    const { claimExpense, claimExpenseError } = { ...this.state }
    let addButtonLabel = localize('pages.SubmitAClaim.Expenses.AddExpenseButton')
    let formTitle = localize('pages.SubmitAClaim.Expenses.AddExpenseFormTitle')
    if (this.props.claimIndx >= 0) {
      addButtonLabel = localize('common.saveUpdates')
      formTitle = localize('pages.SubmitAClaim.Expenses.EditExpenseFormTitle')
    }
    return (
      <div>
        <Row start='xs'>
          <Col xs={12}>
            <h3 className='marginBottom0px'>{formTitle}</h3>
            <p className='titledLabelTitle'>{localize('error.account.activateAccount.20001018')}</p>
          </Col>
        </Row>
        <br />
        <Row start='xs'>
          <Col xs={12}>
            <RBDatePicker
              id='serviceDate'
              label={localize('pages.SubmitAClaim.Expenses.ServiceDate')}
              errorText={claimExpenseError.serviceDate}
              fullWidth
              pickerProps={{
                autoOk: true,
                maxDate: moment(),
                value: claimExpense.serviceDate || null,
                onChange: (v) => this.updateValues({ serviceDate: v })
              }}
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <br />
            <RBNumericTextBox
              textLabel={localize('pages.SubmitAClaim.Expenses.Drug.DIN-NPN-HPN')}
              id='dinNum'
              autoComplete='off'
              format='########'
              onValueChange={this.updateValues}
              onBlur={this.onBlur}
              error={claimExpenseError.dinNum}
              value={claimExpense.dinNum}
              fullWidth
              floatingLabelFixed
            />
          </Col>
        </Row>
        {/* render the din details */}
        {this.state.dinState.isValid ? (
          <Row start='xs'>
            <Col xs={12}>
              <p style={{ marginTop: -6, fontSize: 12, position: 'relative', color: '#7d7d7d', fontWeight: 500 }}>{this.state.dinState.name}</p>
            </Col>
          </Row>
        ) : (this.state.dinState.isSearching ? <LinearProgress color='primary' style={{ position: 'relative', bottom: 12 }} /> : null)}
        <Row start='xs'>
          <Col xs={12}>
            <RBNumericTextBox
              textLabel={localize('pages.SubmitAClaim.Expenses.Drug.RX')}
              id='rxNum'
              autoComplete='off'
              format='##########'
              onValueChange={this.updateValues}
              error={claimExpenseError.rxNum}
              value={claimExpense.rxNum}
              fullWidth
              floatingLabelFixed
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <RBSelectField
              data={this.props.provinces}
              floatingLabelFixed
              id='province'
              defaultText={localize('pages.SubmitAClaim.Expenses.Drug.ProvinceOfPharmacy')}
              label={localize('pages.SubmitAClaim.Expenses.Drug.ProvinceOfPharmacy')}
              sendValues={this.updateValues}
              errorText={claimExpenseError.province}
              selected={claimExpense.province}
              fullWidth />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <RBNumericTextBox
              textLabel={localize('pages.SubmitAClaim.Expenses.Drug.NumberOfDaysSupply')}
              id='supplyDays'
              format='###'
              autoComplete='off'
              onValueChange={this.updateValues}
              error={claimExpenseError.supplyDays}
              value={claimExpense.supplyDays}
              fullWidth
              floatingLabelFixed
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <RBSelectField
              data={this.props.quantityTypes}
              id='quantityType'
              defaultText={localize('pages.SubmitAClaim.Expenses.Drug.QuantityType')}
              label={localize('pages.SubmitAClaim.Expenses.Drug.QuantityType')}
              onChanged={this.quantityTypeChanged}
              errorText={claimExpenseError.quantityType}
              selected={claimExpense.quantityType}
              fullWidth />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <RBNumericTextBox
              textLabel={localize('pages.SubmitAClaim.Expenses.Drug.DrugQuantity')}
              id='drugQuantity'
              autoComplete='off'
              onValueChange={this.updateValues}
              error={claimExpenseError.drugQuantity}
              value={claimExpense.drugQuantity}
              format='#######'
              fullWidth
              floatingLabelFixed
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <PaidByOtherTextField
              textLabel={localize('pages.SubmitAClaim.Expenses.Drug.DrugCostWithoutDispenseFee')}
              id='drugCost'
              floatingLabelFixed
              fullWidth
              onValueChange={this.updateValues}
              error={claimExpenseError.drugCost}
              value={claimExpense.drugCost}
              labelStyles={{ width: '140%' }}
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <PaidByOtherTextField
              textLabel={localize('pages.SubmitAClaim.Expenses.Drug.DispenseFee')}
              id='dispenseFee'
              floatingLabelFixed
              fullWidth
              onValueChange={this.updateValues}
              value={claimExpense.dispenseFee}
              error={claimExpenseError.dispenseFee}
            />
          </Col>
        </Row>
        {this.props.hasCOB
          ? <Row start='xs'>
            <Col xs={12}>
              <PaidByOtherTextField
                textLabel={localize('pages.SubmitAClaim.Expenses.AmountReceivedByOther')}
                floatingLabelFixed
                fullWidth
                id='paidByOtherAmount'
                autoComplete='off'
                onValueChange={this.updateValues}
                error={claimExpenseError.paidByOtherAmount}
                value={claimExpense.paidByOtherAmount}
                labelStyles={{ width: '125%' }}
              />
            </Col>
          </Row>
          : null
        }
        <Row start='xs'>
          <Col xs={12}>
            <TitledLabel title={localize('pages.SubmitAClaim.Expenses.TotalReceiptAmount')} value={formatCurrency(Number(this.state.claimExpense.drugCost) + Number(this.state.claimExpense.dispenseFee || 0) - Number(this.state.claimExpense.paidByOtherAmount || 0))} />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12} sm={6}>
            <RBButton fullWidth variant='outlined' label={localize('common.cancel')} onClick={this.onCancel} className={classnames(classes.margin)} />
          </Col>
          <Col xs={12} sm={6}>
            <RBButton fullWidth variant='contained' label={addButtonLabel} primary onClick={this.onAddExpense} className={classnames(classes.margin)} />
          </Col>
        </Row>
      </div>
    )
  }

  render () {
    return (
      <Grid fluid style={{ overflowY: 'scroll', height: '100vh', overflowX: 'hidden' }}>
        {this.renderDrugForm()}
      </Grid>
    )
  }
}

function mapStateToProps (state, ownProps) {
  const quantityTypes = (state.SubmitExpenseReducer.quantityTypes || []).map((quantityTypes) => {
    return { id: quantityTypes, text: quantityTypes }
  })
  const provinces = (state.SubmitExpenseReducer.provinces || []).map((prov) => {
    return { id: prov, text: prov }
  })
  return {
    claimObj: state.SubmitAClaimReducer.claimObj,
    error: state.SubmitAClaimReducer.error,
    quantityTypeLoading: state.SubmitExpenseReducer.quantityTypeLoading,
    quantityTypes: quantityTypes,
    quantityTypeError: state.SubmitExpenseReducer.quantityTypeError,
    provinces: provinces
  }
}
const ConnectedManageDrugExpense = connect(mapStateToProps, { fetchQuantityTypes, fetchProvinces, SearchDIN })(injectIntl(ManageDrugExpense))
const Styles = {
  margin: {
    marginTop: 10
  }
}

export default withStyles(Styles)(ConnectedManageDrugExpense)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/ManageDrugExpense/index.js